// extracted by mini-css-extract-plugin
module.exports = {"entityDetails":"entityDetails_entityDetails__1pKbN","logo":"entityDetails_logo__2den6"};